export const WIDGET_TYPES = {
  COMMENTS: 'comments',
  DATE: 'date',
  MARKDOWN: 'markdown',
  PRIORITY: 'priority',
  TAGS: 'tags',
};
